import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Loader from 'halogen/RingLoader'
import { Button, Row, Col } from 'react-bootstrap';
import TimeOffTables from '../components/TimeOffTables.js';
// import AbsenceTables from '../components/AbsenceTables.js';
import MakeUpTable from '../components/MakeUpTable.js';
import { connect } from 'react-redux';

class Admin extends Component {
  constructor(props) {
    super(props);

    const { isLeaderOrAdmin } = this.props;

    if (!isLeaderOrAdmin) {
      window.location.href = '/dashboard';
      return true;
    }

  }

  render() {
    const { isAdmin, user, members } = this.props
    const memberIds = Object.keys(members)
    if (!user) {
      return (
        <Loader color="#26194b" size="120px" className="loader" />
      )
    }

    return (
      <div className="Admin">
        <Row>
          { user.name ? (
            <h1>Welcome back, {user.name}!</h1>
          ) : (
            <h1>Welcome back!</h1>
          ) }
        </Row>
        <Row className="actions">
          <Link to="/timeoff">
            <Button bsStyle="primary">
              Add Timeoff
            </Button>
          </Link>
          <Link to="/makeup">
            <Button bsStyle="primary" style={{marginRight: 10}}>
              Add Make-up Day
            </Button>
          </Link>
          { isAdmin
            ? <Link to="/admin/user">
              <Button bsStyle="primary" style={{marginRight: 10}}>
                View Users
              </Button>
            </Link> : null
          }

        </Row>
        <TimeOffTables
          admin
          userFilter={memberIds}
        />
        <Row>
          <Col xs={12} md={6}>
            <h2>Make-up Days</h2>
            <MakeUpTable
              userFilter={memberIds}
            />
          </Col>
        </Row>
        {/* <Row>
          <Col xs={12} md={6}>
            <AbsenceTables
              admin
            />
          </Col>
        </Row> */}
      </div>
    );

  }
}

const mapStateToProps = (state) => {
  const { user, isAdmin, isLeaderOrAdmin, members } = state.auth;
  return { user, isAdmin, isLeaderOrAdmin, members };
}

export default connect(mapStateToProps)(Admin);



// WEBPACK FOOTER //
// ./src/page/Admin.js